import { Attributes } from '@leverege/ui-attributes';
export const CHANGE_STATES = {
  PENDING: 'Pending Change',
  COMPLETE: 'Up To Date',
  INITIALIZING: 'Initializing',
  MANUFACTURING: 'Manufacturing'
};
export default {
  id: 'locator.operationStateChangeStatus',
  name: 'locator.operationStateChangeStatus',
  displayName: 'Operation State Change Status',
  valueType: 'string',
  objectType: 'locator',
  blueprint: {},
  get: obj => {
    const desiredState = Attributes.get('locator.desiredOperationState', 'locator', obj);
    const reportedState = Attributes.get('locator.reportedOperationState', 'locator', obj);
    if (desiredState != null && reportedState != null) {
      return desiredState === reportedState ? CHANGE_STATES.COMPLETE : CHANGE_STATES.PENDING;
    }
    if (desiredState == null && reportedState == null) {
      return CHANGE_STATES.MANUFACTURING;
    }
    if (desiredState == null) {
      return CHANGE_STATES.INITIALIZING;
    }
    if (reportedState == null) {
      return CHANGE_STATES.PENDING;
    }
    return null;
  }
};